import { IApplicationState } from '../../../../types/types';
import { getAuthUser, SNOOZE_BLOCKER_MINUTES, SNOOZE_BLOCKER_PRO_FEATURES } from './getAuthUser';
import { EProductPack } from '../../../../view/react_components/dialogs/price_page/types';
import { getBoardIsOnSharedDrive } from '../../selectors/getBoardIsOnSharedDrive';
import { getActiveBoardId } from '../../selectors/getActiveBoardId';
import { IAuthUser } from '../types';
import { getProductById } from 'app/store/model/authUser/selectors/getProductById';

export const getIsUserStarterPlanOnly = (
    state: IApplicationState
): boolean => {
    const user = getAuthUser(state);
    const snoozeBlockerTime = user.meta && user.meta.snoozeBlockerTime;
    const isSnoozeActive = snoozeBlockerTime && Date.now() - snoozeBlockerTime < SNOOZE_BLOCKER_MINUTES * 60 * 1000;
    let isStarterPlan = false;
    const subscriptions = user.activeSubscription;
    if ( // KNB-3493 сейчас показываем новый дизайн и плашки pro и стартеру и без подписки легаси юзерам
        !subscriptions.length &&
        !getBoardIsOnSharedDrive(state, getActiveBoardId(state)) &&
        !isSnoozeActive &&
        !user[SNOOZE_BLOCKER_PRO_FEATURES[0] as keyof IAuthUser] // проверяем, что это не фримиум
    ) {
        return true;
    }
    let i = subscriptions.length;
    while( i--) {
        const { productId } = subscriptions[i];
        if (getProductById(productId).pack.id === EProductPack.PREMIUM) {
            isStarterPlan = true;
        } else if (getProductById(productId).pack.id === EProductPack.PROFESSIONAL || getProductById(productId).pack.id === EProductPack.ENTERPRISE) {
            isStarterPlan = false;
            break;
        }
    }
    return isStarterPlan;
};
